function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isPair } from '../nodes/identity.js';
import { Pair } from '../nodes/Pair.js';
import { YAMLMap } from '../nodes/YAMLMap.js';
import { YAMLSeq } from '../nodes/YAMLSeq.js';
import { resolveEnd } from './resolve-end.js';
import { resolveProps } from './resolve-props.js';
import { containsNewline } from './util-contains-newline.js';
import { mapIncludes } from './util-map-includes.js';
var blockMsg = 'Block collections are not allowed within flow collections';

var isBlock = function isBlock(token) {
  return token && (token.type === 'block-map' || token.type === 'block-seq');
};

function resolveFlowCollection(_ref, ctx, fc, onError, tag) {
  var _tag$nodeClass;

  var composeNode = _ref.composeNode,
      composeEmptyNode = _ref.composeEmptyNode;
  var isMap = fc.start.source === '{';
  var fcName = isMap ? 'flow map' : 'flow sequence';
  var NodeClass = (_tag$nodeClass = tag === null || tag === void 0 ? void 0 : tag.nodeClass) !== null && _tag$nodeClass !== void 0 ? _tag$nodeClass : isMap ? YAMLMap : YAMLSeq;
  var coll = new NodeClass(ctx.schema);
  coll.flow = true;
  var atRoot = ctx.atRoot;
  if (atRoot) ctx.atRoot = false;
  if (ctx.atKey) ctx.atKey = false;
  var offset = fc.offset + fc.start.source.length;

  for (var i = 0; i < fc.items.length; ++i) {
    var collItem = fc.items[i];
    var start = collItem.start,
        key = collItem.key,
        sep = collItem.sep,
        value = collItem.value;
    var props = resolveProps(start, {
      flow: fcName,
      indicator: 'explicit-key-ind',
      next: key !== null && key !== void 0 ? key : sep === null || sep === void 0 ? void 0 : sep[0],
      offset: offset,
      onError: onError,
      parentIndent: fc.indent,
      startOnNewline: false
    });

    if (!props.found) {
      if (!props.anchor && !props.tag && !sep && !value) {
        if (i === 0 && props.comma) onError(props.comma, 'UNEXPECTED_TOKEN', "Unexpected , in ".concat(fcName));else if (i < fc.items.length - 1) onError(props.start, 'UNEXPECTED_TOKEN', "Unexpected empty item in ".concat(fcName));

        if (props.comment) {
          if (coll.comment) coll.comment += '\n' + props.comment;else coll.comment = props.comment;
        }

        offset = props.end;
        continue;
      }

      if (!isMap && ctx.options.strict && containsNewline(key)) onError(key, // checked by containsNewline()
      'MULTILINE_IMPLICIT_KEY', 'Implicit keys of flow sequence pairs need to be on a single line');
    }

    if (i === 0) {
      if (props.comma) onError(props.comma, 'UNEXPECTED_TOKEN', "Unexpected , in ".concat(fcName));
    } else {
      if (!props.comma) onError(props.start, 'MISSING_CHAR', "Missing , between ".concat(fcName, " items"));

      if (props.comment) {
        var prevItemComment = '';

        var _iterator = _createForOfIteratorHelper(start),
            _step;

        try {
          loop: for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var st = _step.value;

            switch (st.type) {
              case 'comma':
              case 'space':
                break;

              case 'comment':
                prevItemComment = st.source.substring(1);
                break loop;

              default:
                break loop;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (prevItemComment) {
          var _prev$value;

          var prev = coll.items[coll.items.length - 1];
          if (isPair(prev)) prev = (_prev$value = prev.value) !== null && _prev$value !== void 0 ? _prev$value : prev.key;
          if (prev.comment) prev.comment += '\n' + prevItemComment;else prev.comment = prevItemComment;
          props.comment = props.comment.substring(prevItemComment.length + 1);
        }
      }
    }

    if (!isMap && !sep && !props.found) {
      // item is a value in a seq
      // → key & sep are empty, start does not include ? or :
      var valueNode = value ? composeNode(ctx, value, props, onError) : composeEmptyNode(ctx, props.end, sep, null, props, onError);
      coll.items.push(valueNode);
      offset = valueNode.range[2];
      if (isBlock(value)) onError(valueNode.range, 'BLOCK_IN_FLOW', blockMsg);
    } else {
      // item is a key+value pair
      // key value
      ctx.atKey = true;
      var keyStart = props.end;
      var keyNode = key ? composeNode(ctx, key, props, onError) : composeEmptyNode(ctx, keyStart, start, null, props, onError);
      if (isBlock(key)) onError(keyNode.range, 'BLOCK_IN_FLOW', blockMsg);
      ctx.atKey = false; // value properties

      var valueProps = resolveProps(sep !== null && sep !== void 0 ? sep : [], {
        flow: fcName,
        indicator: 'map-value-ind',
        next: value,
        offset: keyNode.range[2],
        onError: onError,
        parentIndent: fc.indent,
        startOnNewline: false
      });

      if (valueProps.found) {
        if (!isMap && !props.found && ctx.options.strict) {
          if (sep) {
            var _iterator2 = _createForOfIteratorHelper(sep),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _st = _step2.value;
                if (_st === valueProps.found) break;

                if (_st.type === 'newline') {
                  onError(_st, 'MULTILINE_IMPLICIT_KEY', 'Implicit keys of flow sequence pairs need to be on a single line');
                  break;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }

          if (props.start < valueProps.found.offset - 1024) onError(valueProps.found, 'KEY_OVER_1024_CHARS', 'The : indicator must be at most 1024 chars after the start of an implicit flow sequence key');
        }
      } else if (value) {
        if ('source' in value && value.source && value.source[0] === ':') onError(value, 'MISSING_CHAR', "Missing space after : in ".concat(fcName));else onError(valueProps.start, 'MISSING_CHAR', "Missing , or : between ".concat(fcName, " items"));
      } // value value


      var _valueNode = value ? composeNode(ctx, value, valueProps, onError) : valueProps.found ? composeEmptyNode(ctx, valueProps.end, sep, null, valueProps, onError) : null;

      if (_valueNode) {
        if (isBlock(value)) onError(_valueNode.range, 'BLOCK_IN_FLOW', blockMsg);
      } else if (valueProps.comment) {
        if (keyNode.comment) keyNode.comment += '\n' + valueProps.comment;else keyNode.comment = valueProps.comment;
      }

      var pair = new Pair(keyNode, _valueNode);
      if (ctx.options.keepSourceTokens) pair.srcToken = collItem;

      if (isMap) {
        var map = coll;
        if (mapIncludes(ctx, map.items, keyNode)) onError(keyStart, 'DUPLICATE_KEY', 'Map keys must be unique');
        map.items.push(pair);
      } else {
        var _map = new YAMLMap(ctx.schema);

        _map.flow = true;

        _map.items.push(pair);

        var endRange = (_valueNode !== null && _valueNode !== void 0 ? _valueNode : keyNode).range;
        _map.range = [keyNode.range[0], endRange[1], endRange[2]];
        coll.items.push(_map);
      }

      offset = _valueNode ? _valueNode.range[2] : valueProps.end;
    }
  }

  var expectedEnd = isMap ? '}' : ']';

  var _fc$end = _toArray(fc.end),
      ce = _fc$end[0],
      ee = _fc$end.slice(1);

  var cePos = offset;
  if (ce && ce.source === expectedEnd) cePos = ce.offset + ce.source.length;else {
    var name = fcName[0].toUpperCase() + fcName.substring(1);
    var msg = atRoot ? "".concat(name, " must end with a ").concat(expectedEnd) : "".concat(name, " in block collection must be sufficiently indented and end with a ").concat(expectedEnd);
    onError(offset, atRoot ? 'MISSING_CHAR' : 'BAD_INDENT', msg);
    if (ce && ce.source.length !== 1) ee.unshift(ce);
  }

  if (ee.length > 0) {
    var end = resolveEnd(ee, cePos, ctx.options.strict, onError);

    if (end.comment) {
      if (coll.comment) coll.comment += '\n' + end.comment;else coll.comment = end.comment;
    }

    coll.range = [fc.offset, cePos, end.offset];
  } else {
    coll.range = [fc.offset, cePos, cePos];
  }

  return coll;
}

export { resolveFlowCollection };